import React from 'react'
import Responsive from 'react-responsive'

import { sizes } from '../themes/index'

export const Desktop = props => (
  <Responsive {...props} minWidth={sizes.desktop} maxWidth={sizes.large - 1} />
)
export const Tablet = props => (
  <Responsive {...props} minWidth={sizes.tablet} maxWidth={sizes.desktop - 1} />
)
export const Phone = props => (
  <Responsive {...props} maxWidth={sizes.tablet - 1} />
)
export const Default = props => <Responsive {...props} minWidth={sizes.large} />
